import getBusinessName from 'utils/print/getBusinessName';
import getBusinessAddress from 'utils/print/getBusinessAddress';

const getBusinessNameAndAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const businessName = getBusinessName(otherProps);
  const businessAddress = getBusinessAddress(otherProps);
  return businessName && businessAddress
    ? `${businessName}, ${businessAddress}` : null;
};

export default getBusinessNameAndAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessNameAndAddress.js